/* eslint-disable import/prefer-default-export */
export const ContentLoadCount = {
  web: {
    all: 20,
    news: 30,
    photos: 33,
    videos: 32,
  },
  mweb: {
    all: 20,
    news: 30,
    photos: 33,
    videos: 32,
  },
};
export const topStoriesMsid = '-2128958273';
